import { ArrowRight, Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import { scrollToId } from "@/lib/scroll";
import { Editable } from "@/components/builder/Editable";
import { useContent } from "@/context/ContentContext";

export const MidCTA = () => {
  const { ctaClick } = useContent();
  return (
    <section className="section-lavender">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8">
        <div className="card-soft relative overflow-hidden px-6 py-12 text-center sm:px-12">
          <div className="absolute inset-0 bg-grid-faint opacity-30" aria-hidden="true" />
          <div className="relative">
            <p className="mb-3 inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.16em] text-primary"><Gift className="h-4 w-4" /> <Editable path="mid.eyebrow">Programma Partner Sedio</Editable></p>
            <Editable as="h2" path="mid.title" className="block font-display text-3xl font-extrabold text-foreground sm:text-4xl">Il modo migliore per valutare Sedio è provarlo.</Editable>
            <Editable as="p" path="mid.desc" className="mx-auto mt-3 block max-w-xl text-base leading-7 text-muted-foreground">Accedi gratis e scopri Sedio sui tuoi casi reali: comunicazione, segnalazioni e pratiche gestite dall'AI. Nessuna chiamata, nessun impegno.</Editable>
            <div className="mt-7"><Button data-testid="midpage-cta-button" size="lg" onClick={ctaClick("mid.cta.link", "https://app.sedio.it")} className="btn-cta h-12 gap-2 px-8 text-base"><Editable path="mid.cta">Provalo gratis</Editable> <ArrowRight className="h-4 w-4" /></Button></div>
          </div>
        </div>
      </div>
    </section>
  );
};
